import React from 'react';

/** A pet mid-emote, a heart popping up, lines for the moment: live emotes. */
export default function LiveEmoteIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <rect x="4" y="11" width="11" height="9" rx="3" fill={color} opacity="0.15" />
      <rect x="4" y="11" width="11" height="9" rx="3" stroke={color} strokeWidth="1.5" />
      <path d="M5.5 11 6.3 8.6 8.2 11M13.5 11l-.8-2.4-1.9 2.4" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
      {/* Happy closed eyes */}
      <path d="M7 15c.4-.6 1.2-.6 1.6 0M10.4 15c.4-.6 1.2-.6 1.6 0" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
      {/* Heart popping up */}
      <path d="M18.5 9.2c-.3 0-2.7-1.5-2.7-3.2 0-.9.7-1.6 1.5-1.6.5 0 .9.3 1.2.7.3-.4.7-.7 1.2-.7.8 0 1.5.7 1.5 1.6 0 1.7-2.4 3.2-2.7 3.2Z"
            fill={color} />
      {/* Motion lines */}
      <path d="M17.5 13.5h3M17 16.5h2" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    </svg>
  );
}
